export const GTM = {
  trackEvent: payload => {
    // ensuring we are in a browser, the datalayer exists, and that it is the proper type of object. If all are good we can push to it.
    if (process.browser && window.dataLayer && Array.isArray(window.dataLayer)) {
      window.dataLayer.push(payload);
    }
  }
};
